import TenantsPage from '@totem/components/tenants/tenantsPage/TenantsPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfilePage from '@totem/components/userProfile/UserProfile';
import UserDetailsPage from '@totem/components/users/details/userDetailsPage';
import MyWorkPage from '@totem/components/users/myWork/MyWorkPage';
import UserManagement from '@totem/components/users/UserManagement';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const userRoutes: Route[] = [
  {
    path: 'userProfile',
    pageTitle: 'User Profile',
    component: UserProfilePage,
    exact: true,
    breadcrumbs: [{ label: 'User Profile' }],
  },
  {
    path: 'user/myWork',
    pageTitle: 'My Work',
    component: MyWorkPage,
    exact: true,
    breadcrumbs: [{ label: 'My Work' }],
  },
  {
    path: 'usermanagement',
    pageTitle: 'Users',
    component: UserManagement,
    exact: true,
    breadcrumbs: [{ label: 'Users' }],
    render: (userProfile: UserProfile) =>
      permissions.organizationalAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'usermanagement/:id',
    pageTitle: 'User',
    component: UserDetailsPage,
    exact: true,
    breadcrumbs: [{ label: 'User' }],
    render: (userProfile: UserProfile) =>
      permissions.organizationalAdministrator.hasPermissions(userProfile),
  },
  {
    path: 'tenants',
    pageTitle: 'Tenants',
    component: TenantsPage,
    exact: true,
    breadcrumbs: [],
    render: (userProfile: UserProfile) =>
      permissions.organizationalAdministrator.hasPermissions(userProfile),
  },
];
